import { useStaticQuery, graphql } from "gatsby"

export const useFoundationImages = () => {
  const data = useStaticQuery(graphql`
    query {
      _001_small: file(
        relativePath: { eq: "img/foundation/Small001-min.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 700, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      _002_small: file(
        relativePath: { eq: "img/foundation/Small002-min.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 700, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      _003_small: file(
        relativePath: { eq: "img/foundation/Small003-min.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 700, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
    }
  `)
  return data
}
